'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1App3 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    app: state.moduleData.data.module1.app3,
    allModule: state.moduleData.data.module1
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App3, _Component);

  function Module1App3() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App3);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App3.__proto__ || (0, _getPrototypeOf2.default)(Module1App3)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 3,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'What is a serve?',
      foodGroups: [{
        title: 'Vegetables',
        show: false,
        component: _react2.default.createElement(_components.VegetableServe, null)
      }, {
        title: 'Fruit',
        show: false,
        component: _react2.default.createElement(_components.FruitServe, null)
      }],
      extraFoodGroups: [{
        title: 'Grain',
        show: false,
        component: _react2.default.createElement(_components.GrainServe, null)
      }, {
        title: 'Meats',
        show: false,
        component: _react2.default.createElement(_components.MeatServe, null)
      }, {
        title: 'Dairy',
        show: false,
        component: _react2.default.createElement(_components.DairyServe, null)
      }]
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      // this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, { 'isCompleted': true });

      // update the overarching module's details
      // this.props.updateModule(this.props.user.userId, this.state.moduleId, {
      //   'numAppCompleted': numAppCompleted,
      //   'numAppTotal': this.props.allModule.numAppTotal});

      // this.props.changeItem(this.state.moduleId, 0, this.state.appId + 1);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1App3, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'When we talk about \'amounts\' of food, we usually say \'serves\'. Learning about \'serves\' will help you give your child the right amount of different foods.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'The Australian Guide to Healthy Eating (AGHE) stipulates the number of serves required for individuals of different genders, age and life-stage across the five \'core\' food groups:'
          ),
          _react2.default.createElement(
            ReactBootstrap.Accordion,
            null,
            this.state.foodGroups.map(function (item, index) {
              return _react2.default.createElement(
                ReactBootstrap.Panel,
                { key: 'panel' + index, header: item.title, eventKey: index },
                item.component
              );
            })
          ),
          _react2.default.createElement(
            'p',
            null,
            'As vegetables and fruit are the focus of Reboot Kids, ',
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'Meats '
            ),
            ',',
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              ' Grains'
            ),
            ', and ',
            _react2.default.createElement(
              'strong',
              { className: styles.orangeText },
              'Dairy '
            ),
            ' are discussed in Extra Info.'
          ),
          _react2.default.createElement('div', { className: styles.spacer40 }),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer100 })
        )
      );
    }
  }]);
  return Module1App3;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module1App3;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App3.js
// module id = 1166
// module chunks = 0